<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import TemplateService from "@/helpers/template.service.js";

import { projectData } from "./data-projects";

/**
 * Projects-grid component
 */
export default {
  page: {
    title: "Select Template",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      projectData: projectData,
      title: "Select Template",
      items: [
        {
          text: "Project",
          href: "/",
        },
        {
          text: "Select Template",
          active: true,
        },
      ],
      template: [],
      backUrl: "/project",
    };
  },
  methods: {
    getTemplate() {
      TemplateService.getTemplate()
        .then((res) => {
          this.template = res.data.data;
          console.log("allala", res);
        })
        .catch((err) => {});
    },
    base64_encode(text) {
      return btoa(text);
    },
  },
  mounted() {
    this.getTemplate();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />
    <div class="row">
      <div
        v-for="grid in template"
        :key="grid.id"
        class="col-xl-6 col-sm-6 mb-4"
      >
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="avatar-md mr-4">
                <span
                  class="
                    avatar-title
                    rounded-circle
                    bg-light
                    text-danger
                    font-size-16
                  "
                >
                  <img
                    :src="require('@/assets/images/' + grid.template_icon)"
                    alt
                    height="50"
                  />
                </span>
              </div>

              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-15">
                  <a href="#" class="text-dark">{{ grid.template_name }}</a>
                </h5>
                <p
                  class="text-muted text-justify mb-4 text-wrap text-truncate"
                  style="height: 10vh"
                >
                  {{ grid.template_desc }}
                </p>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 border-top">
            <ul class="list-inline mb-0 align-middle">
              <li
                v-b-tooltip.hover.top
                class="list-inline-item mr-3"
                title="Comments"
              >
                <i class="bx bx-user mr-1"></i>
                {{ grid.target_count }} target
              </li>
              <li class="list-inline-item float-right">
                <div
                  v-if="
                    grid.template_name === 'Personal' ||
                    grid.template_name === 'Anonymous'
                  "
                >
                  <router-link
                    :to="{
                      name: 'create-target-personal',
                      query: {
                        q: base64_encode(grid.id_template),
                      },
                    }"
                  >
                    <b-button size="sm" variant="primary">
                      <i class="bx bx-plus-circle bx-xs align-middle mr-2"></i>
                      Create
                    </b-button>
                  </router-link>
                </div>
                <div
                  v-if="
                    grid.template_name === 'Partai' ||
                    grid.template_name === 'Media' ||
                    grid.template_name === 'Organisasi'
                  "
                >
                  <router-link
                    :to="{
                      name: 'create-target-non-personal',
                      query: { q: base64_encode(grid.id_template) },
                    }"
                  >
                    <b-button size="sm" variant="primary">
                      <i class="bx bx-plus-circle bx-xs align-middle mr-2"></i>
                      Create
                    </b-button>
                  </router-link>
                </div>
                <!-- <div v-if="grid.template_name === 'Media'">
                  <router-link :to="{ name: 'create-target-media' }">
                    <b-button size="sm" variant="primary">
                      <i class="bx bx-plus-circle bx-xs align-middle mr-2"></i>
                      Create
                    </b-button>
                  </router-link>
                </div>
                <div v-if="grid.template_name === 'Organisasi'">
                  <router-link :to="{ name: 'create-target-organisasi' }">
                    <b-button size="sm" variant="primary">
                      <i class="bx bx-plus-circle bx-xs align-middle mr-2"></i>
                      Create
                    </b-button>
                  </router-link>
                </div>
                <div v-if="grid.template_name === 'Anonymous'">
                  <router-link :to="{ name: 'create-target-anon' }">
                    <b-button size="sm" variant="primary">
                      <i class="bx bx-plus-circle bx-xs align-middle mr-2"></i>
                      Create
                    </b-button>
                  </router-link>
                </div> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- end ro w -->
  </Layout>
</template>